<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <n-divide class="table-tools">
      <div></div>
      <n-link v-if="edit.lab" :to="createRecordLink()"><n-button>Создать запись</n-button></n-link>
    </n-divide>

    <n-table :columns="columns" :data="data">
      <template #headerRow>
        <tr class="header">
          <td rowspan="2">№ п/п</td>
          <td rowspan="2">Номер линии</td>
          <td rowspan="2">Дата предыдущей првоерки, номера линии однотипных сварных стыков выполненных сварщиком после неe</td>
          <td rowspan="2">Дата сварки контролируемого сварного соединения</td>
          <td rowspan="2">Номер сварного соединения по чертежам (исполнительным чертежам)</td>
          <td rowspan="2">Температура, условия проведения сварки, ГРС</td>
          <td rowspan="2">Труба (ДнхS), мм, марка стали (композиция марок сталей)</td>
          <td colspan="4">Сварочные материалы</td>
          <td rowspan="2">Фамилия, инициалы сварщика, клеймо и подпись сварщика</td>
          <td rowspan="2">Дата термической обработки, регистрационный номер в журнале</td>
          <td rowspan="2">Фамилия и инициалытермиста-оператора, клеймо и подпись</td>
          <td rowspan="2">Дата и номер протокола замератвердости</td>
          <td colspan="6">Результат контроля качества сварки</td>
          <td rowspan="2">Заключение о качестве проконтролированных сварных соединений и допуске сварщика к сварке однотипных сварных соединений</td>
          <td rowspan="2">Фамилия и инициалы начальника сварочной лаборотории, подпись, дата</td>
          <td rowspan="2"></td>
        </tr>
        <tr class="header">
          <td>Электрод</td>
          <td>Проволока</td>
          <td>флюс</td>
          <td>Защитный газ</td>
          <td>Радиографический или ультразвуковой контроль, номер заключения</td>
          <td>Механический свойства сварного соединения образца, вырезанного из контрольного стыка,номер протокола, дата</td>
          <td>Металография, номер протокола, дата</td>
          <td>ферритная фаза, номер протокола, дата</td>
          <td>Склонность к МКК, номер протокола, дата</td>
          <td>Фамилия и инициалы дефектоскописта, номер удостоверения, подпись, дата</td>
        </tr>
        <tr class="header">
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>4</td>
          <td>5</td>
          <td>6</td>
          <td>7</td>
          <td>8</td>
          <td>9</td>
          <td>10</td>
          <td>11</td>
          <td>12</td>
          <td>13</td>
          <td>14</td>
          <td>15</td>
          <td>16</td>
          <td>17</td>
          <td>18</td>
          <td>19</td>
          <td>20</td>
          <td>21</td>
          <td>22</td>
          <td>23</td>
          <td>24</td>
          <td></td>
        </tr>
      </template>
      <template #date="{item}">
        {{ $app.date.format(item.date) }}
      </template>
      <template #termSign="{item}">
        <c-journal-sign :sign="getSign(item, 'term')" />
      </template>
      <template #welderSign="{item}">
        <c-journal-sign :sign="getSign(item, 'welder')" />
      </template>
      <template #labSign="{item}">
        <c-journal-sign :sign="getSign(item, 'lab')" />
      </template>
      <template #defectSign="{item}">
        <c-journal-sign :sign="getSign(item, 'defect')" />
      </template>
      <template #tools="{item}">
        <n-link :to="showRecordLink(item.id)"><n-button icon="eye" /></n-link>
      </template>
    </n-table>

    <page-record-create v-if="newRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(createRecordLink(false))" />
    <modal-record v-if="showRecord" :project="project" :journal="journal" @reload="load" @close="$router.push(showRecordLink(false))" />
  </div>
</template>

<script>
import PageRecordCreate from './Create'
import ModalRecord from './record/Index'
import utils from 'utils'
import CJournalSign from 'components/journal/Sign'

export default {
  name: 'MainChapter4',
  components: { CJournalSign, ModalRecord, PageRecordCreate, },
  props: [ 'project', 'journal', ],
  data: () => ({
    utils,
    data: [
    ],
  }),
  computed: {
    newRecord() {
      return this.$route.query['new'] !== undefined
    },
    showRecord() {
      return this.$route.query['show'] !== undefined
    },
    edit() {
      return {
        lab: $app.auth.can('journals_'+this.journal.name+'_lab', this.project.id),
      }
    },
    columns() {
      return [
        { name: 'number', title: '', },
        { name: 'lineNum', title: '', },
        { name: 'lastCheckDate', title: '', },
        { name: 'weldingDate', title: '', },
        { name: 'weldingNum', title: '', },
        { name: 'temp', title: '', },
        { name: 'pipe', title: '', },
        { name: 'electrod', title: '', },
        { name: 'provoloka', title: '', },
        { name: 'flus', title: '', },
        { name: 'guardingGas', title: '', },
        { name: 'welderSign', title: '', },
        { name: 'termDate', title: '', },
        { name: 'termSign', title: '', },
        { name: 'protocolNum', title: '', },
        { name: 'result1', title: '', },
        { name: 'result2', title: '', },
        { name: 'result3', title: '', },
        { name: 'result4', title: '', },
        { name: 'result5', title: '', },
        { name: 'defectSign', title: '', },
        { name: 'remark', title: '', },
        { name: 'labSign', title: '', },
        { name: 'tools', title: '', },
      ]
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load() 
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journals.records.get(this.project.id, this.journal.name)
        .query({
          'with[records][with][participation]': null,
          'with[signs][with][author]': null,
          projectId: this.project.id,
        })
        .then((response) => {
          this.data = response.data.content
        }).finally(() => {
          this.$var('load', false)
        })
    },
    getUser(item, name) {
      if (!item[name]) {
        return ''
      }
      return item[name]?.participation?.position + ', ' + item[name]?.fullName
    },
    createRecordLink(open = true) {
      return { query: { ...this.$route.query, 'new': open ? null : undefined, }, }
    },
    showRecordLink(open) {
      return { query: { ...this.$route.query, 'show': open || undefined, }, }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
  },
}
</script>

<style lang="scss" scoped>
.main-chapter1 {

}
</style>
